var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C24.1366 0 28.0585 1.43515 31.4732 4.09212C34.8878 6.7297 37.7951 10.5891 39.8829 15.4182C40.039 15.7867 40.039 16.2133 39.8829 16.5624C35.7073 26.2206 28.2732 32 20 32H19.9805C11.7268 32 4.29268 26.2206 0.117073 16.5624C-0.0390244 16.2133 -0.0390244 15.7867 0.117073 15.4182C4.29268 5.76 11.7268 0 19.9805 0H20ZM20 8.24242C15.6878 8.24242 12.1951 11.7139 12.1951 16C12.1951 20.2667 15.6878 23.7382 20 23.7382C24.2927 23.7382 27.7854 20.2667 27.7854 16C27.7854 11.7139 24.2927 8.24242 20 8.24242ZM20.0023 11.1472C22.6755 11.1472 24.8609 13.3194 24.8609 15.9957C24.8609 18.6527 22.6755 20.8248 20.0023 20.8248C17.3097 20.8248 15.1243 18.6527 15.1243 15.9957C15.1243 15.666 15.1633 15.3557 15.2219 15.0454H15.3194C17.4853 15.0454 19.2414 13.3388 19.3194 11.2054C19.534 11.1666 19.7682 11.1472 20.0023 11.1472Z",
    fill: "#8895A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowIcon);
export default __webpack_public_path__ + "static/media/showIcon.6af3fd07774b5d7a61d46bb7ba4fe6b5.svg";
export { ForwardRef as ReactComponent };